import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import configs from '@/config'
import SystemConnection, { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

let resource = null

const actions = {
  createEmbedSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/embed/{slideId}`,
  },
  getEmbedSlide: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/embed/{slideId}`,
  },
  updateEmbedSlide: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/slide/embed/{slideId}`,
  },
  deleteEmbedSlide: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/slide/embed/{slideId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createEmbedSlide = async (params) => {
  try {
    return await resource.createEmbedSlide(params)
  } catch (error) {
    Sentry.captureException(error)
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const getEmbedSlide = async (slideId) => {
  try {
    return resource.getEmbedSlide({ slideId })
  } catch (error) {
    Sentry.captureException(error)
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const updateEmbedSlide = async (slideId, slideData) => {
  try {
    return resource.updateEmbedSlide({ slideId }, slideData)
  } catch (error) {
    Sentry.captureException(error)
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const deleteEmbedSlide = async (slideId) => {
  try {
    return await resource.deleteEmbedSlide({ slideId })
  } catch (error) {
    Sentry.captureException(error)
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

export default {
  initResource,
  createEmbedSlide,
  getEmbedSlide,
  updateEmbedSlide,
  deleteEmbedSlide,
}
